<template>
  <template-info :bgImg="bgImg" title="รายละเอียดค่าปรับต่างๆ">
    <div>
      ค่าปรับต่างๆที่อาจเกิดขึ้น ได้แก่<br /><br />
      <div class="wivb-detail">
        <span>ค่าปรับอาญา</span> เกิดในกรณีไม่ได้ยื่นแบบ ภพ.30
        (ไม่เคยยื่นแบบมาก่อน)
      </div>

      <div class="wivb-detail">
        <span>เงินเพิ่ม</span>
        คิดในอัตราร้อยละ 1.5 ต่อเดือนของภาษี ที่ต้องชำระ (เศษของเดือนนับเป็น 1
        เดือน)
        กรณีไม่มีภาษีต้องเสียก็ไม่ต้องจ่ายเงินเพิ่มจะเสียแต่ค่าปรับอาญาไม่ยื่นแบบเท่านั้น
      </div>

      <div class="wivb-detail">
        <span>เบี้ยปรับ</span> การเสียค่าปรับแบ่งได้ 2 กรณี
        คือกรณียื่นแบบเพิ่มเติม (ต้องมีการยื่นแบบปกติมาก่อน)
        กับกรณีไม่เคยยื่นแบบมาก่อน (อาจจะลืมยื่นหรือมีเงินไม่พอจ่ายก็เลยไม่ยื่น)
      </div>
      <external-link
        @clickLink="readMoreInfo"
        caption="ดูข้อมูลเพิ่มเติม"
        class="link-desktop"
        style="margin-top: 30px;"
      />
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/fine_detail.png";

export default {
  name: "FineDetail",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    goVatBenefit() {
      this.$router.push({
        path: "/info/vat_benefit",
      });
    },
    readMoreInfo() {
      window.open(
        "https://www.rd.go.th/publish/fileadmin/user_upload/SMEs/infographic/20.vat_360.pdf",
        "_blank"
      );
    },
  },
};
</script>

<style scoped>
.wivb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 20px;
  text-align: left;
}
.wivb-detail > span {
  font-weight: bold;
}
</style>
